(function () {
  const OBSERVER_URL =
    'https://the-argentino-cart-observer.gerenciatheargentino.workers.dev/';

  let observerRunning = false;

  function isCartAddUrl(url) {
    try {
      const value = String(url || '');
      return (
        value.includes('/cart/add.js') ||
        value.includes('/cart/add')
      );
    } catch (e) {
      return false;
    }
  }

  async function observeCart() {
    if (observerRunning) return;

    observerRunning = true;

    try {
      const cartResponse = await fetch('/cart.js', {
        credentials: 'same-origin'
      });

      if (!cartResponse.ok) return;

      const cart = await cartResponse.json();

      if (!cart || !cart.token || !cart.item_count) return;

      const storageKey = 'ta_cart_observed_' + cart.token;

      if (localStorage.getItem(storageKey) === '1') {
        return;
      }

      const lastItem =
        Array.isArray(cart.items) && cart.items.length
          ? cart.items[cart.items.length - 1]
          : null;

      const payload = {
        event: 'cart_first_add',

        cartToken: cart.token || null,
        cartValue: cart.total_price || null,
        itemCount: cart.item_count || null,

        productId: lastItem?.product_id || null,
        variantId: lastItem?.variant_id || null,
        productTitle: lastItem?.product_title || null,
        quantity: lastItem?.quantity || null,

        page: window.location.href
      };

      const response = await fetch(OBSERVER_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload),
        keepalive: true
      });

      if (response.ok) {
        localStorage.setItem(storageKey, '1');
      }

    } catch (e) {
      // El observer nunca debe afectar la compra.
    } finally {
      observerRunning = false;
    }
  }

  // Detectar Add to cart realizados con fetch()
  const originalFetch = window.fetch;

  window.fetch = async function () {
    const args = arguments;
    const requestUrl =
      typeof args[0] === 'string'
        ? args[0]
        : args[0]?.url;

    const response = await originalFetch.apply(this, args);

    if (isCartAddUrl(requestUrl) && response.ok) {
      setTimeout(observeCart, 150);
    }

    return response;
  };

  // Detectar Add to cart realizados con XMLHttpRequest
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._taCartObserverUrl = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (isCartAddUrl(this._taCartObserverUrl)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          setTimeout(observeCart, 150);
        }
      });
    }

    return originalSend.apply(this, arguments);
  };
})();